const percentageFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
  style: 'percent',
});

export function formatPercentage(value: number): string {
  return percentageFormatter.format(value);
}
